import React, { useRef, useState, useEffect } from "react";
import { Button, Box } from "@mui/material";

interface Props {
  text: string;
  onChange: (value: string) => void;       // Para resultados finales
  onInterim?: (value: string) => void;     // Para resultados interinos
  onRecordingStateChange?: (recording: boolean) => void;
}

const SugerenciaConDictado: React.FC<Props> = ({
  text,
  onChange,
  onInterim,
  onRecordingStateChange,
}) => {
  const recognizerRef = useRef<any>(null);
  const [isRecording, setIsRecording] = useState(false);
  const textRef = useRef(text);

  useEffect(() => {
    textRef.current = text;
  }, [text]);

  const idioma = navigator.languages?.[0] || navigator.language || "es-ES";

  const iniciarGrabacion = async () => {
    const SpeechRecognition =
      (window as any).webkitSpeechRecognition ||
      (window as any).SpeechRecognition;

    if (!SpeechRecognition) {
      alert("Tu navegador no soporta reconocimiento de voz.");
      return;
    }

    // Solicita permiso explícitamente para que el navegador muestre su diálogo nativo
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach((t) => t.stop()); // libera el micrófono de inmediato
    } catch {
      // El usuario denegó el permiso en el diálogo del navegador
      return;
    }

    const recognizer = new SpeechRecognition();
    recognizerRef.current = recognizer;

    recognizer.lang = idioma;
    recognizer.continuous = true;
    recognizer.interimResults = true;

    recognizer.onresult = (event: any) => {
      let interim = "";
      let final = "";

      for (let i = event.resultIndex; i < event.results.length; i++) {
        const result = event.results[i];
        if (result.isFinal) {
          final += result[0].transcript + " ";
        } else {
          interim += result[0].transcript;
        }
      }

      if (final) {
        const current = textRef.current;
        const nuevoTexto = current ? current + " " + final.trim() : final.trim();
        onChange(nuevoTexto);
      }

      onInterim?.(interim);
    };

    recognizer.onstart = () => setIsRecording(true);
    recognizer.onend = () => setIsRecording(false);
    recognizer.onerror = (event: any) => {
      if (event.error !== "no-speech") {
        alert(`Error de reconocimiento de voz: ${event.error}`);
      }
    };

    recognizer.start();
  };

  const detenerGrabacion = () => {
    recognizerRef.current?.stop();
  };

  useEffect(() => {
    onRecordingStateChange?.(isRecording);
  }, [isRecording]);

  return (
    <Box display="flex" gap={1}>
      {!isRecording ? (
        <Button variant="outlined" onClick={iniciarGrabacion}>
          🎤 Iniciar dictado
        </Button>
      ) : (
        <Button variant="contained" color="error" onClick={detenerGrabacion}>
          ⏹ Detener
        </Button>
      )}
    </Box>
  );
};

export default SugerenciaConDictado;
